const INTERACTIVE_TARGET_SELECTOR = [
  'a',
  'button',
  'input',
  'textarea',
  'select',
  'option',
  'label',
  'summary',
  '[contenteditable="true"]',
  '[role="button"]',
  '[role="textbox"]',
  '[role="link"]',
  '[role="checkbox"]',
  '[role="menuitem"]',
  '[data-no-drag]',
].join(',');

export function isHoverCardDragIgnoredTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return true;
  }
  return Boolean(target.closest(INTERACTIVE_TARGET_SELECTOR));
}
